<template>
    <div class="sidebar" v-click-away="toggleVisibleMinimized">
        <nav class="sidebar-nav">
            <perfect-scrollbar class="scroll-area" :options="psOptions">
                <ul class="nav">
                    <template v-for="item in navItems">
                        <template v-if="item.title && item.disabled == false">
                            <sidebar-nav-title :key="item.clientKey" :name="item.label" :classes="item.class" :wrapper="item.wrapper" />
                        </template>
                        <template v-else-if="item.divider">
                            <li :key="item.clientKey" class="divider"></li>
                        </template>
                        <template v-else>
                            <template v-if="item.hasChildren && item.disabled == false">
                                <sidebar-nav-dropdown ref="dropDownComponents" :key="item.clientKey" :item="item" :minimized="minimized" @itemClick="onDropdownClick" />
                            </template>
                            <template v-else-if="item.disabled == false">
                                <sidebar-nav-link :linkId="item.id" :key="item.clientKey" :item="item" @click="onLinkClick" />
                            </template>
                        </template>
                    </template>
                </ul>
                <slot></slot>
            </perfect-scrollbar>
        </nav>
        <div class="sidebar-footer">
            <slot name="footer">
            </slot>
        </div>
    </div>
</template>
<script>
    /* eslint-disable */
    import { NavItem, NavConfig } from "@/shared/nav";
    import { mixin as VueClickAway } from "vue3-click-away";
    import SidebarNavDropdown from "./SidebarNavDropdown";
    import SidebarNavLink from "./SidebarNavLink";
    import SidebarNavTitle from "./SidebarNavTitle";

    export default {
        name: "Sidebar",
        mixins: [ VueClickAway ],
        components: { SidebarNavDropdown, SidebarNavLink, SidebarNavTitle },
        data() {
            return {
                minimized: false,
                navItems: []
            };
        },
        computed:{
            psOptions() {
                return {
                    maxScrollbarLength: 200,
                    minScrollbarLength: 40,
                    suppressScrollX: true,
                    wheelPropagation: false,
                    interceptRailY: styles => ({ ...styles, height: 0 })
                }
            }
        },
        created() {
            this.initializeNavItems();
            this.$events.on("sidebar::toggleMinimized", this.onToggleMinimized);
            this.$router.beforeEach((to, from, next) => {
                this.toggleVisibleMinimized();
                next();
            });
        },
        methods: {
            initializeNavItems() {
                let items = _.map(_.uniq(NavConfig.items), item => ({ ...item, disabled: false }));
                items.forEach(item => this.checkAccess(item));
                let mappedItems = _.map(items, item => new NavItem(item));
                this.navItems = _.filter(mappedItems, item => !item.inactive);
            },
            onToggleMinimized(e) {
                this.minimized = e.value;
                this.toggleVisibleMinimized();
            },
            onDropdownClick(e) { this.toggleVisibleMinimized(e.item.clientKey); },
            onLinkClick(e) { this.toggleVisibleMinimized(); },
            toggleVisibleMinimized(targetItemKey=null) {
                if(!this.minimized) return;
                let components = _.get(this, "$refs.dropDownComponents", []);
                _.forEach(components, c => {
                    c.item.visibleMinimized = c.item.clientKey === targetItemKey;
                    //will also collapse children if hidden
                    c.refreshVisibleMinimized();
                });
            },
            checkAccess(item) {
                if (!item.minimumPermission || item.minimumPermission == "FileAdmin") {
                    item.disabled = false;
                    if (item.children) {
                        for (var i=0; i< item.children.length; i++) {
                            var child = item.children[i];
                            this.checkAccess(child);
                        }
                    }
                    return;
                }

                let permissions = this.$store.getters.user.userPermissions;
                item.disabled = true;
                for (var i=0; i< permissions.length; i++) {
                    var permission = permissions[i];
                    if (permission.name == "SiteAdmin") {
                        item.disabled = false;
                    }
                    if (item.minimumPermission == "InternalAdmin" && permission.name == "InternalAdmin") {
                        item.disabled = false;
                    }
                }
                if (item.children) {
                    for (var i=0; i< item.children.length; i++) {
                        var child = item.children[i];
                        this.checkAccess(child);
                        if (child.disabled == false) {
                            item.disabled = false;
                        }
                    }
                }
            }
        }
    };
</script>